import React, { useRef, useState } from 'react'
import {
  Button,
  Card,
  Tag,
  Input,
  Icon,
  Table
} from 'antd'
import { compose, graphql, withApollo } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import CoinTransactionForm from './CoinTransactionForm'
import {
  fetchCoinPackageTransaction,
  confirmCoinTransaction
} from '../../modules/coin'
import _ from 'lodash'
import moment from 'moment';
import Highlighter from 'react-highlight-words'
import Lightbox from "react-image-lightbox";
import { HERO_COIN_STATUS } from '../../utils/constants'
import "../../../node_modules/react-image-lightbox/style.css";

const CoinTransaction = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [current, setCurrent] = useState('')
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')

  const { coinPackageTransaction, isLoading } = useSelector(
    (state) => ({
      coinPackageTransaction: state.coin.coinPackageTransaction,
      isLoading: state.coin.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchCoinPackageTransaction())
    }

    fetch()
  }, [])

  const GetStatusColor = (status) => {
    let color = ''
    if (status !== null) {
      switch (status.toUpperCase()) {
        case 'PAYMENT_SUCCESS':
          color = 'gold'
          break
        case 'PAYMENT_PENDING':
          color = 'blue'
          break
        case 'ADDCOIN_SUCCESS':
          color = 'green'
          break
        case 'PAYMENT_INVALID':
          color = 'red'
          break
        case 'PAYMENT_CANCEL':
          color = 'orange'
          break
        case 'TIMEOUT':
          color = 'volcano'
          break
        default:
          break
      }
    }
    return color
  }
  const handleClickImage = (e, image) => {
    e && e.preventDefault();
    setCurrent(image)
  };

  const handleCloseModal = e => {
    e && e.preventDefault();
    setCurrent('')
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const GetDateTime = (datetime) => {
    let submitdate = ''
    if (datetime !== null) {
      submitdate = moment(datetime).format('DD/MM/YYYY HH:mm')
    }
    return submitdate
  }


  const columns = [
    {
      title: 'วันที่ทำการซื้อ',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => {
        const datesubmit = GetDateTime(createdAt)
        return (
          <span>
            {datesubmit}
          </span>
        )
      }
    },
    {
      title: 'รายการที่ซื้อ',
      dataIndex: 'coinPackage.name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'จำนวนเหรียญ',
      dataIndex: 'coinPackage.coin',
    },
    {
      title: 'ราคา',
      dataIndex: 'coinPackage.cost',
    },
    {
      title: 'ผู้ซื้อ',
      dataIndex: 'heroName',
      key: 'heroName',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status ? HERO_COIN_STATUS[status] : status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'หลักฐานการโอน',
      key: 'paymentSlip',
      dataIndex: 'paymentSlip',
      render: (image, record) =>
        <span>
          <div>
            {image ?
              <span>
                <img
                  src={image}
                  width={100}
                  height={100}
                  style={{ marginRight: 10, objectFit: 'cover' }}
                  alt="img"
                  onClick={e => handleClickImage(e, image)}
                />
                {current && (
                  <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
                )}
              </span>
              : '-'
            }
          </div>
        </span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          {record.status == "PAYMENT_SUCCESS" ?
            <Button
              type="primary"
              size="small"
              shape="circle"
              icon="edit"
              onClick={(e) => {
                onClick(e, record)
              }}
            />
            : ''}

        </span>
      )
    }
  ]

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await dispatch(fetchCoinPackageTransaction())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(confirmCoinTransaction(data))
    }

    await dispatch(fetchCoinPackageTransaction())
    await setVisible(false)
    await setFormData({})
  }

  return (
    <Card
      title="Coin Transaction">
      <br />
      <Table
        loading={isLoading}
        bordered
        dataSource={coinPackageTransaction}
        columns={columns}
        rowKey={(record) => {
          return record.id
        }}
      />
      <CoinTransactionForm
        visible={visible}
        formData={formData}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

export default compose(withApollo)(CoinTransaction)
